export default __webpack_public_path__ + "static/media/zyfzrq.c1e8dc32.jpg";